import { gql } from '@apollo/client'

export default {
  updateCameraReworkStatus: () => gql`
    mutation UpdateCameraReworkStatus($updateParams: UpdateCameraReworkStatusInput) {
      updateCameraReworkStatus(params: $updateParams) {
        code
        message
        newStatus
      }
    }
  `,
  updateGroupData: () => gql`
    mutation UpdateGroupData($updateParams: UpdateGroupDataInput!) {
      updateGroupData(params: $updateParams) {
        code
        success
        message
        errorFields
        group {
          volumes
          changeHistory {
            user {
              contactName
            }
            type
            opCode
            date {
              gedcomX
              fromTimestamp
            }
            coverages {
              place {
                fullName
                id
              }
              recordTypes {
                apolloId
                id
                name
                date {
                  fromTimestamp
                  toTimestamp
                  gedcomX
                }
              }
            }
            metadata {
              title
              volume
              languages
              archivalReferenceNumber
              creator
            }
          }
          id
          imageViewerCoverages {
            place {
              fullName
              id
            }
            recordTypes {
              apolloId
              id
              name
              date {
                fromTimestamp
                toTimestamp
                gedcomX
              }
            }
          }
          imageApids
          internalData {
            cameraOperator
            cameraOperatorNumber
            id
            originalMediaNumber
            phoenixAcquisitionIds
          }
          metadata {
            title
            volumes
            languages
            createdDate {
              fromTimestamp
              gedcomX
            }
            creator
            currentDate {
              fromTimestamp
              gedcomX
            }
            custodian
            archivalReferenceNumber
            imageGroupNumber
            place
          }
        }
      }
    }
  `,
  updateNaturalGroups: () => gql`
    mutation UpdateNaturalGroups($parentGroupId: ID!, $newNaturalGroups: [NaturalGroupUpdateInput]!) {
      updateNaturalGroups(parentGroupId: $parentGroupId, newNaturalGroups: $newNaturalGroups)
    }
  `,
  updateWorkflowActionStatus: () => gql`
    mutation UpdateWorkflowActionStatus($params: UpdateWorkflowActionStatusInput) {
      updateWorkflowActionStatus(params: $params) {
        code
        success
        newStatus
        message
      }
    }
  `,
  updateWorkflowActionStatusList: () => gql`
    mutation UpdateWorkflowActionStatusList($actionStatusList: [UpdateWorkflowActionStatusInput]) {
      updateWorkflowActionStatusList(actionStatusList: $actionStatusList) {
        code
        success
        message
      }
    }
  `,
  updateMetisProjectStatus: () => gql`
    mutation UpdateMetisProjectStatus($updateParams: UpdateMetisProjectInput) {
      updateMetisProjectStatus(params: $updateParams) {
        code
        success
        message
        metisProject {
          id
          workflowActions {
            name
            status
          }
        }
      }
    }
  `,
  suggestNewAuditPercentage: () => gql`
    mutation SuggestNewImageAudit($auditPercentageSuggestion: auditPercentageSuggestionInput) {
      suggestNewImageAudit(auditPercentageSuggestion: $auditPercentageSuggestion) {
        code
        success
        message
      }
    }
  `,
  reserveAuditCoverages: () => gql`
    mutation ReserveAuditCoverages($parentGroupId: ID!) {
      reserveAuditCoverages(parentGroupId: $parentGroupId) {
        code
        success
        message
      }
    }
  `,
}
